<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-col cols="12">
      <transition name="slide">
        <b-card
          tag="article"
          style="max-width: 100%"
          class="mb-2"
          header-tag="header"
        >
          <template #header>
            <h5>Cadastro de Produtos</h5>
          </template>
          <b-row>
            <b-col xl="6" lg="6" md="12" sm="12">
              <b-form-group>
                <b-input-group size="md" prepend="Barras">
                  <b-form-input
                    type="search"
                    id="sku"
                    placeholder="Digite o código de barras"
                    v-model="sku"
                    @keyup.enter="focus('description')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col xl="6" lg="6" md="12" sm="12">
              <b-form-group>
                <b-input-group size="md" prepend="Descrição">
                  <b-form-input
                    type="search"
                    id="description"
                    placeholder="Digite a descrição"
                    v-model="description"
                    @keyup.enter="focus('stockQuantity')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="6" lg="6" md="12" sm="12">
              <b-form-group>
                <b-input-group size="md" prepend="Estoque">
                  <b-form-input
                    type="search"
                    id="stockQuantity"
                    placeholder="Digite a quantidade em estoque"
                    v-model="stockQuantity"
                    @keyup.enter="focus('salePrice')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col xl="6" lg="6" md="12" sm="12">
              <b-form-group>
                <b-input-group size="md" prepend="Valor">
                  <b-form-input
                    type="search"
                    id="salePrice"
                    v-model="salePrice"
                    placeholder="Digite o valor"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="4" lg="4" md="4" sm="4">
              <h4 align="center">Foto</h4>
              <picture-input
                ref="imgProduct"
                :zIndex="1"
                :crop="false"
                :removable="true"
                margin="16"
                accept="image/jpeg, image/png"
                size="10"
                button-class="changeBtn"
                removeButtonClass="removeBtn"
                :custom-strings="{
                  upload:
                    '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                  tap: `1<br>Clique aqui para <br> selecionar uma imagem`,
                  drag: `1<br>Arraste uma imagem <br> (ou clique aqui)`,
                  change: 'Mudar foto',
                  remove: 'Remover foto',
                }"
                @change="onChange"
              >
              </picture-input>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-button
                class="my-2 my-sm-0 mr-sm-2 w100"
                type="submit"
                @click="postProducts()"
                :disabled="edit"
              >
                <i class="fa fa-check fa-xl"></i>
                Confirmar
              </b-button>
              <b-button
                class="my-2 my-sm-0 mr-sm-2 w100"
                type="submit"
                @click="redirect('Consulta')"
              >
                <i class="fa fa-sign-out fa-xl"></i>
                Retornar
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </transition>
    </b-col>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import PictureInput from "vue-picture-input";
import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "AddProducts",
  components: { Loading, PictureInput },
  data: () => {
    return {
      isLoading: false,
      sku: "",
      description: "",
      stockQuantity: null,
      salePrice: null,
      image: "",
      edit: true
    };
  },

  methods: {
    redirect(ref) {
      if (ref == "Consulta") {
        this.$router.push(`/products-list`);
      }
    },

    onChange(image) {
      if (image) {
        localStorage.setItem("image", image);
      }
    },

    focus(id) {
      document.getElementById(id).focus();
    },

    async postProducts() {
      const url = `${config.default.urlBase}/oac/site/products`;
      try {
        const response = await axios({
          url: url,
          method: "post",
          headers: { authorization: `${config.default.authorization}` },
          data: {
            site: {
              token:
                "31fd2fe4dcb2f44b8be871e01f78be258297a3c272432ecd1d0413f991d12081",
              cnpj: "37018781000151",
            },
            product: {
              sku: this.sku,
              description: this.description,
              stockQuantity: this.stockQuantity,
              salePrice: this.salePrice.replace(",", "."),
              image: localStorage.getItem("image"),
            },
          },
        });

        this.$vToastify.success("Produto Cadastrado!", "Sucesso");

        localStorage.removeItem("image");

        this.sku = "";
        this.description = "";
        this.stockQuantity = null;
        this.salePrice = null;
        this.image = "";

        this.$router.push(`/productsList`);
      } catch (error) {
        this.$vToastify.error("Produto não Cadastrado!", "Erro");
        console.error({
          errorMessage: `[PostProducts] ${error}`,
        });
      }
    },

    // postProducts() {
    //   const url = `${config.default.urlBase}/oac/site/products`;

    //   return axios({
    //     url: url,
    //     method: "post",
    //     headers: { authorization: `${config.default.authorization}` },
    //     data: {
    //       site: {
    //         token:
    //           "31fd2fe4dcb2f44b8be871e01f78be258297a3c272432ecd1d0413f991d12081",
    //         cnpj: "37018781000151",
    //       },
    //       product: {
    //         sku: this.sku,
    //         description: this.description,
    //         stockQuantity: this.stockQuantity,
    //         salePrice: this.salePrice.replace(",", "."),
    //         image: localStorage.getItem("image"),
    //       },
    //     },
    //   })
    //     .then((response) => {
    //       this.$vToastify.success("Produto Cadastrado!", "Sucesso");

    //       localStorage.removeItem("image");

    //       this.sku = "";
    //       this.description = "";
    //       this.stockQuantity = null;
    //       this.salePrice = null;
    //       this.image = "";

    //       this.$router.push(`/productsList`);
    //     })
    //     .catch((error) => {
    //       this.$vToastify.error("Produto não Cadastrado!", "Erro");
    //       console.error({
    //         errorMessage: `[PostProducts] ${error}`,
    //       });
    //     });
    // },
  },

  async beforeMount() {
    this.isLoading = true;

    this.sku = this.$route.params.sku;
    this.description = this.$route.params.description;
    this.salePrice = this.$route.params.salePrice;
    this.stockQuantity = this.$route.params.stockQuantity;

    console.log({
      sku: this.$route.params.sku,
      description: this.$route.params.description,
      salePrice: this.$route.params.salePrice,
      stockQuantity: this.$route.params.stockQuantity
    });
    this.isLoading = false;
  },
};
</script>